import React, { useContext, useState } from "react";
import { AuthContext } from "../../context/AuthContext";
import { ModalContext } from "../../context/ModalContext";

const ChangePasswordModal = () => {
  const [currentPassword, setCurrentPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false);

  const { updatePassword } = useContext(AuthContext);
  const { alert, clearModal } = useContext(ModalContext);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (currentPassword === "" || newPassword === "") {
      return alert("Debes llenar todos los campos");
    }
    if (newPassword.length < 6) {
      return alert("Tu nueva contraseña debe tener al menos 6 caracteres.");
    }
    if (newPassword !== confirmPassword) {
      return alert("Las contraseñas no coinciden");
    }
    setLoading(true);
    updatePassword(
      currentPassword,
      newPassword,
      () => clearModal(),
      () => setLoading(false)
    );
  };

  const renderPasswordInput = (label, value, setValue) => (
    <>
      <label className="mb-1">{label}</label>
      <div className="input-group mb-3">
        <input
          type={showPassword ? "text" : "password"}
          className="form-control"
          value={value}
          onChange={(e) => setValue(e.target.value)}
        />
        <button
          type="button"
          className="btn btn-outline-secondary btn-eye"
          onClick={() => setShowPassword(!showPassword)}
          aria-label={showPassword ? "Ocultar contraseñas" : "Mostrar contraseñas"}
        >
          <i className={`fa fa-eye${showPassword ? "-slash" : ""}`}></i>
        </button>
      </div>
    </>
  );

  return (
    <form onSubmit={handleSubmit}>
      {renderPasswordInput(
        "Contraseña actual",
        currentPassword,
        setCurrentPassword
      )}
      {renderPasswordInput("Nueva contraseña", newPassword, setNewPassword)}
      {renderPasswordInput(
        "Confirmar nueva contraseña",
        confirmPassword,
        setConfirmPassword
      )}
      <div className="row">
        <div className="col-6">
          <button
            type="button"
            onClick={clearModal}
            disabled={loading}
            className="btn btn-link text-muted w-100"
          >
            Cancelar
          </button>
        </div>
        <div className="col-6">
          <button
            type="submit"
            disabled={loading}
            className="btn btn-primary w-100"
          >
            {loading ? (
              <div className="spinner-border spinner-border-sm" />
            ) : (
              "Guardar"
            )}
          </button>
        </div>
      </div>
    </form>
  );
};

export default ChangePasswordModal;
